import { StatsigClient } from '@statsig/react-bindings'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { ENABLE_SVD_FLOW_DISCOVERY } from '@src/config/svd-flags'

/**
 * Non-hook read of the `ramp_svd-rollout-web` experiment for service-layer
 * code (cart/checkout enrichment, product cards, collection) that runs outside
 * React. Replaces the removed `smart_variant_enabled` gate — the on/off
 * decision now comes from the discovery team's SVD rollout experiment, with
 * semantics identical to `useIsSvdEnabled`:
 * - dark while the program-wide `ENABLE_SVD_FLOW_DISCOVERY` kill-switch is off
 *   (no experiment read, no Statsig exposure),
 * - on only when the user resolves to the `show` group.
 *
 * `StatsigClient.instance()` resolves the client registered by the
 * StatsigProvider. On the server, or when no client exists yet, every failure
 * mode degrades to `false` so callers fall back to the v1 paths.
 */
export const getSvdExperimentValue = (): boolean => {
  if (typeof window === 'undefined') return false
  if (!ENABLE_SVD_FLOW_DISCOVERY) return false
  try {
    const experiment = StatsigClient.instance().getExperiment(STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT)
    return experiment.groupName === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT].buckets?.show
  } catch (error) {
    console.error('Failed while checking SVD rollout experiment outside React', error)
    return false
  }
}
